

export default function accordion() {




    const accordions = document.querySelectorAll('.js-accordion');
        
    if ( accordions.length ) {
        accordions.forEach(accordion => {
            const title = accordion.querySelector('.main-course__accordion-title');
            const content = accordion.querySelector('.main-course__accordion-content');
            const btn = title.querySelector('.main-course__accordion-btn');
            
            // Обработчик клика по заголовку или кнопке
            title.addEventListener('click', function() {
              // Переключаем класс is-active для контента
              content.classList.toggle('is-active');
              
              // Переключаем иконку между плюсом и минусом (если нужно)
              const svgPath = btn.querySelector('path');
              /* if (content.classList.contains('is-active')) {
                // Меняем на иконку минуса (если нужно)
                svgPath.setAttribute('d', 'M15 25H35');
              } else {
                // Возвращаем иконку плюса
                svgPath.setAttribute('d', 'M26.5417 24.4585H35.9167V26.5418H26.5417V35.9168H24.4584V26.5418H15.0834V24.4585H24.4584V15.0835H26.5417V24.4585Z');
              } */
            });
          });
    }

    

}